// @ts-nocheck
/* eslint-disable */
export const stdCheckIcon = {
    data: `<?xml version="1.0" encoding="UTF-8"?><svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="ico-/-check" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="icons_check"><path id="Path" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" d="M5 11 9 15 19 5"/><path id="Path" d="M0 0 24 0 24 24 0 24z"/></g></g></svg>`,
    name: 'check' as const
};